import React, { useState } from 'react'
import { Modal } from 'antd'
import { connect } from 'react-redux'
import { getColorByIndex } from '../../../../../utils/colors.helper'
import ComponentWithEditor from '../components/ComponentWithEditor'

const ModalWithEditor = ({
    assignment,
    drawer,
    patternsList: customPatternsList,
    patternIdsToShow,
    selectedSnippets,
    children,
    width,
    afterOpenChange,
    ...rest
}) => {
    const [animationOfModalHasFinished, setAnimationOfModalHasFinished] = useState(false)

    const editorShouldBeShown = drawer.file.content
    let patternsList
    if (editorShouldBeShown) {
        patternsList = customPatternsList
            ? customPatternsList
            : drawer?.file?.motifList?.map(motif => {
                  return {
                      motifId: motif.motif_id,
                      startRow: motif.start_row,
                      endRow: motif.end_row,
                      color: getColorByIndex(motif.color_id).value,
                  }
              })
        
        // Filter patterns if patternIdsToShow is provided
        if (patternIdsToShow && patternsList) {
            patternsList = patternsList.filter(pattern => 
                patternIdsToShow.includes(pattern.motifId)
            )
        }
    }

    const mergedAfterOpenChange = open => {
        afterOpenChange && afterOpenChange(open)
        setAnimationOfModalHasFinished(true)
    }

    return (
        <Modal
            {...rest}
            open
            wrapClassName='modal-with-editor'
            afterOpenChange={mergedAfterOpenChange}
            width={editorShouldBeShown ? width : width / 2}
        >
            <ComponentWithEditor
                name={drawer.file.name}
                content={drawer.file.content}
                language={assignment.language}
                patternsList={patternsList}
                selectedSnippets={selectedSnippets}
                showEditor={editorShouldBeShown}
                loading={!animationOfModalHasFinished}
            >
                {children}
            </ComponentWithEditor>
        </Modal>
    )
}

const mapState = ({ assignment }) => {
    return {
        assignment: assignment.assignment,
        drawer: assignment.drawer,
    }
}

export default connect(mapState, null)(ModalWithEditor)
